//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import { API } from '@/util/api'
import { Toast } from 'vant';
import demandAddForm from '../modules/demandAddForm'
import moment from 'moment'
import { fileutil } from '@/util/fileutil'
export default {
  name: 'demand',
  data(){
    return {
      societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
      societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : window.localStorage.getItem('societyName'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
      userInfo: this.$store.getters.getUserInfo, // 登录用户信息
      inType: (this.$route.query.inType != null && this.$route.query.inType != '' ) ? this.$route.query.inType : 3,//从哪儿进来的   0首页点击案例进入    1搜索页点击案例进入  2机构首页进入    3需求页进入
      visible: false,
      // 需求明细信息
      demandInfo: {},
      selCompanyObj: {
        page: {
          pageNum: 0,
          pageSize: 6
        }
      },
      companyInfoShow: {
        companyInfoList: []
      },
      loadCompanyName: '加载更多',
      companyNoMore: false,
      moment
    }
  },
  components:{
    Header,
    Footer,
    demandAddForm
  },
  computed:{

  },
  methods:{
    fnQueryDemandInfo () {
      this.$store.dispatch('demand/selUserDemandById', JSON.stringify({id: this.demandId}))
        .then(res => {
          console.log('fnQueryDemandInfo res ===>', res)
          if (res.data.retCode == 1) {
            this.demandInfo = res.data.obj
            this.fnLoadCompanyInfo()
          }else{
            Toast("客户需求已撤销，即将返回平台首页");
            setTimeout(this.$router.push({path: '/home'}),1000)
          }
        }).catch(err => {
          console.log(err)
        })
    },
    fnGotoDemand () {
      // 'demandType': this.demandInfo.sysProdTypeId,
      this.$router.push({path: '/demand',query: {'selType': 1}});
    },
    fnLoadCompanyInfo () {
      if (this.companyNoMore) {
        Toast('没有更多了')
        return;
      }
      this.selCompanyObj.companyType = this.demandInfo.sysProdTypeId
      this.selCompanyObj.cityCode = this.demandInfo.cityCode
      console.log('this.selCompanyObj===>', this.selCompanyObj)
      this.$store.dispatch('company/selCompanyInfoPageFormEs', JSON.stringify(this.selCompanyObj))
        .then(res => {
          console.log('fnLoadCompanyInfo res ===>', res)
          if (res.data && res.data.obj != null && res.data.obj.companyInfoList != null &&  res.data.obj.companyInfoList.length == this.selCompanyObj.page.pageSize) {
            this.loadCompanyName = '加载更多'
            this.companyNoMore = false
            this.selCompanyObj.page.pageNum = Number(this.selCompanyObj.page.pageNum) + 1
            let companyInfoList = res.data.obj.companyInfoList;
            companyInfoList.forEach(item => {
              this.companyInfoShow.companyInfoList.push(item)
            })
            if (this.companyInfoShow.companyInfoList.length == res.data.obj.page.total) {
              this.loadCompanyName = '没有更多了'
              this.companyNoMore = true
            }
          } else {
            this.loadCompanyName = '没有更多了'
            this.companyNoMore = true
          }
        }).catch(err => {
          console.log(err)
        })
    },
    handleBtnCloseFormClicked () {
      this.visible = false
    },
    handleBtnOpenFormClicked () {
      this.visible = true
    },
    handleBtnPublishDemandClicked (e) {
      // 发布类似需求
      this.fnStopBub(e);
      // this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:'preweb'})
      this.$refs.demandAddForm.showForm(this.demandInfo)
    },
    handleBtnMoreDemandClicked (e) {
      this.$router.push({
        path: '/demand',
        query: {'demandType': this.demandInfo.sysProdTypeId, 'selType': 1}
      })
    },
    //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    //跳转到需求列表
    fnGotoDemandPage(e){
      this.fnStopBub(e);
       this.$router.push({path: '/demand', query: {selType:1}});
    },
    handleSaveDemandSuccess () {
      // 保存需求成功后回调
    },
    handleLognSucccess (userInfo) {
      this.$refs.Header.fnSetUserInfo(userInfo)
    },
     //跳转到机构主页
    fnGoToSocietyIndexPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/societyIndex', query: {societyId:this.societyId}});
    },
    fnFormatDemandFileImage (fileInfo) {
      if (fileInfo.fileType == '00001') {
        return this.getImageRightPath(fileInfo.zipUrl)
      } else if (fileInfo.fixName == 'xls' || fileInfo.fixName == 'xlsx') {
        return require('../../assets/images/excel.png')
      } else if (fileInfo.fixName == 'doc' || fileInfo.fixName == 'docx') {
        return require('../../assets/images/world.png')
      } else if (fileInfo.fixName == 'cdr') {
        return require('../../assets/images/new1_06.png')
      } else if (fileInfo.fixName == 'psd') {
        return require('../../assets/images/new1_08.png')
      } else if (fileInfo.fixName == 'ai') {
        return require('../../assets/images/new1_10.png')
      } else {
        return require('../../assets/images/currency.png')
      }
    },
    handleFileDownClicked (fileInfo) {
      console.log('handleFileDownClicked fileInfo ===>', fileInfo)
      fileutil.cfsDownload(this, fileInfo.url, fileInfo.fileName)
    }
  },
  mounted(){
    if (this.$route.query && this.$route.query.demandId) {
      this.demandId = this.$route.query.demandId
      this.$nextTick(() => {
        this.fnQueryDemandInfo()
      })
    }
  },
  created(){

  }
}



// WEBPACK FOOTER //
// ./src/pages/demand/demandDetail.vue